<ion-header slot="fixed">
    <ion-toolbar>
        <ion-title mode="ios" role="heading" class="vehicles-detail-header">{{ prompt }}</ion-title>
    </ion-toolbar>
    <ion-toolbar>
        <ion-searchbar aria-live="none" class="item-outline" (ionInput)="filterList($event)" [placeholder]="searchPlaceholder" ></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list aria-live="assertive" aria-atomic="true">
        <ion-item button *ngFor="let item of items; let index = index" attr.aria-label="{{ item.text }}" (click)="onClickRadio(item)" attr.last={{lastItem(index)}}>
            <ion-label aria-hidden="true" [innerHTML]="item.text"></ion-label>
        </ion-item>
    </ion-list>
</ion-content>
